import { TextInput } from "@mantine/core";
import { PageList, ENUM_FORM_DISPLAY } from "../../components/pageList";
import ActionCellRender from "../../components/actionCellRender";
import { IconTrash, IconPencil } from "@tabler/icons";

const apiEntity = "productTypeGroup";

const tableSchema = {
  showActionColumn: true,
  columns: [
    { field: "code", filter: true, width: 180 },
    { field: "name", filter: true, headerName: "Name", width: 280 },
    { field: "cname", filter: true, headerName: "Chinese Name", width: 200 },
    {
      field: "action",
      cellRender: ActionCellRender,
      isAction: true,
      actions: [
        {
          name: "edit",
          icon: IconPencil,
          props: {},
        },
      ],
      actionMenu: [
        {
          name: "delete",
          label: "Delete data",
          icon: IconTrash,
          props: {
            color: "red",
          },
        },
      ],
    },
  ],
  searchableFields: ["code", "name", "cname"],
};

const formSchema = {
  title: "Product Type Group",
  isMainForm: true,
  display: {
    mode: ENUM_FORM_DISPLAY.DRAWER,
    size: "xl",
    position: "right",
  },
  apiEntity,
  initialValues: {
    code: "",
    name: "",
    cname: "",
  },
  layout: {
    fields: [
      {
        name: "code",
        component: TextInput,
        props: {
          required: true,
          label: "Code",
          placeholder: "MOTOR",
        },
      },
      {
        name: "name",
        component: TextInput,
        props: {
          required: true,
          label: "English Name",
        },
      },
      {
        name: "cname",
        component: TextInput,
        props: {
          label: "Chinese Name",
        },
      },
    ],
  },
};

function ProductTypeGroup() {
  return (
    <PageList
      title={"Product Type Groups"}
      apiEntity={apiEntity}
      tableSchema={tableSchema}
      formSchema={formSchema}
    />
  );
}

export default ProductTypeGroup;
